"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_DISPLAY_NAME_ID_LIST = exports.SET_CHART_PARAMS_LIST = exports.SET_ACTIVE_SELECT = exports.SET_ACTIVE_CIRCULATION_GROUP = exports.SET_ACTIVE_CHART_DATA = exports.RESET_CHARTS = exports.REMOVE_ACTIVE_CHART_DATA = exports.GET_CHART_DATA_SUCCEEDED = exports.GET_CHART_DATA_FAILED = exports.GET_CHART_DATA = void 0;
const GET_CHART_DATA = exports.GET_CHART_DATA = 'GET_CHART_DATA';
const GET_CHART_DATA_SUCCEEDED = exports.GET_CHART_DATA_SUCCEEDED = 'GET_CHART_DATA_SUCCEEDED';
const GET_CHART_DATA_FAILED = exports.GET_CHART_DATA_FAILED = 'GET_CHART_DATA_FAILED';
const SET_ACTIVE_CHART_DATA = exports.SET_ACTIVE_CHART_DATA = 'SET_ACTIVE_CHART_DATA';
const REMOVE_ACTIVE_CHART_DATA = exports.REMOVE_ACTIVE_CHART_DATA = 'REMOVE_ACTIVE_CHART_DATA';
const SET_DISPLAY_NAME_ID_LIST = exports.SET_DISPLAY_NAME_ID_LIST = 'SET_DISPLAY_NAME_ID_LIST';
const SET_ACTIVE_CIRCULATION_GROUP = exports.SET_ACTIVE_CIRCULATION_GROUP = 'SET_ACTIVE_CIRCULATION_GROUP';
const SET_ACTIVE_SELECT = exports.SET_ACTIVE_SELECT = 'SET_ACTIVE_SELECT';
const SET_CHART_PARAMS_LIST = exports.SET_CHART_PARAMS_LIST = 'SET_CHART_PARAMS_LIST';
const RESET_CHARTS = exports.RESET_CHARTS = 'RESET_CHARTS';